import {
  ChangeDetectionStrategy,
  Component, OnInit,
  Type
} from "@angular/core";
import { MyUtils } from "src/app/services/my-utils.service";
import { ICol } from "../../models/columns/i-col";
//import { CounterCol } from '../../models/columns/counter-col';
import { ICellComponent } from "../../models/i-cell-component";

@Component({
  selector: "app-counter",
  templateUrl: "./counter.component.html",
  styleUrls: ["./counter.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CounterComponent<T extends object>
  implements OnInit, ICellComponent<T>
{
  data: any[] = [];

  constructor(public utils: MyUtils,) { }

  ngOnInit(): void {

  }

  setComponentData(element: T, colConfig: ICol<T, Type<CounterComponent<T>>>) {
    this.data = colConfig.getElementData(element);
  }
}
